import React, { useState, useEffect, useRef } from 'react'
import {
  Dialog,
} from '@mui/material'
import { SelectChangeEvent } from '@mui/material/Select'
import { useNavigate, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { useAppDispatch, AppDispatch, RootState } from '../../redux/store'
import UseAlert from '../../components/common/useAlerte'
import { addAction } from '../../redux/actions/actionActions'
import { getMissions } from '../../redux/missions/missionActions'
import SelectPriority from '../../components/common/SelectPriority'
import SelectMission from '../../components/common/SelectMission'
import DateSelector from '../../components/common/Date'
import SelectTypeAction from '../../components/common/SelectTypeAction'
import SelectAudit from '../audit/SelectAudit'
import SelectIncident from '../Incident/SelectIncident'
import SelectRisque from '../risque/SelectRisque'
import SelectProjet from '../projets/SelectProjet'
import SecurityControlsSelect from '../securityCheckFamily/SecurityCheckFamilyMain'
import SelectSubDomain from '../../components/common/selectSubDomain'
import SelectSecurity from '../../components/common/SelectSecurity'
import SelectStatut from '../../components/common/SelectStatut'
import ActorAction from '../../components/containers/ActorAction'
import DocumentSelector from '../../components/common/DocumentSelector'
import { createSanitizedObjectHandler } from '../../utils/inputHandlers'
import NumberInput from '../../components/common/NumberInput'
import { DetailButton } from '../../components/common/detail'
import QuickCreate, { QuickCreated, useQuickCreate } from '../../components/quickCreate/QuickCreate'
import { ProjectSummaryCard } from '../../components/quickCreate/ParentSummaryCard'
import { projectLimitViolation, useProjectBudget } from '../../components/quickCreate/parentInfo'
import { useNumberFormat } from '../../hooks/useNumberFormat'
import { formatTableDate } from '../../utils/formatDate'
import { QuickEntity } from '../../components/quickCreate/quickCreateErrors'
import {
  FormAside,
  FormField,
  FormFoot,
  FormGrid,
  FormLayout,
  FormNote,
  FormPageHead,
  FormSection,
  FormShell,
} from '../../components/common/form'
import '../../i18n'
import { ImportTasksButton } from './import/ImportActionsWizard'

const ActionCreate = () => {
  const { idmission } = useParams<{ idmission: string }>()
  const { idprojet } = useParams<{ idprojet: string }>()
  const { t, i18n } = useTranslation()
  const dispatch: AppDispatch = useAppDispatch()
  const navigate = useNavigate()
  const projectReturn =
    idmission && idprojet ? `/mission/${idmission}/projet/${idprojet}` : null
  const leave = () => navigate(projectReturn || '/actions')

  const [SubDomainIds, setSubDomainIds] = useState<string>('')
  const [SecurityControlIds, setSecurityControlIds] = useState<string>('')
  const [openActorPopup, setOpenActorPopup] = useState(false)
  const [openIncompletePopup, setOpenIncompletePopup] = useState(false)
  const pendingMaturityNav = useRef(false)
  const [incompleteSecurityControlName, setIncompleteSecurityControlName] =
    useState('')
  const [maturityFixTarget, setMaturityFixTarget] = useState<{
    familyId: string
    controlId: string
    subDomainId: string
    familyLabel: string
    controlLabel: string
    subDomainLabel: string
  } | null>(null)
  const [SecurityIds, setSecurityIds] = useState<string>('')

  const handleDateChange = (dates: [Date, Date] | null) => {
    if (dates) {
      const [startDate, endDate] = dates
      setAction((prev) => ({
        ...prev,
        DateDebut: startDate,
        DateFin: endDate,
      }))
    }
  }

  const handleMissionChange = (newMission: string) => {
    setAction((prev) => ({
      ...prev,
      MissionId: newMission,
      ProjetId: '',
      SourceAudit: [],
      SourceIncident: [],
      SourceRisque: [],
    }))
  }

  const qc = useQuickCreate()
  const createFor = (kind: QuickEntity) =>
    kind === 'mission' ? qc.open(kind) : action.MissionId ? qc.open(kind, action.MissionId) : undefined

  const handleQuickCreated = (kind: QuickEntity, created: QuickCreated) => {
    qc.close()
    qc.bump(kind)
    const id = created._id as string
    setAction((prev) => {
      if (kind === 'mission')
        return { ...prev, MissionId: id, ProjetId: '', SourceAudit: [], SourceIncident: [], SourceRisque: [] }
      if (kind === 'project') return { ...prev, ProjetId: id }
      if (kind === 'audit') return { ...prev, SourceAudit: [...(prev.SourceAudit ?? []), id] }
      if (kind === 'incident') return { ...prev, SourceIncident: [...(prev.SourceIncident ?? []), id] }
      if (kind === 'risk') return { ...prev, SourceRisque: [...(prev.SourceRisque ?? []), id] }
      return prev
    })
  }

  const handleProjetChange = (event: SelectChangeEvent<string>) => {
    setAction((prev) => ({ ...prev, ProjetId: event.target.value }))
  }

  const handleAuditChange = (event: SelectChangeEvent<string[]>) => {
    setAction((prev) => ({
      ...prev,
      SourceAudit: event.target.value as string[],
    }))
  }

  const handleIncidentChange = (event: SelectChangeEvent<string[]>) => {
    setAction((prev) => ({
      ...prev,
      SourceIncident: event.target.value as string[],
    }))
  }

  const handleRisqueChange = (event: SelectChangeEvent<string[]>) => {
    setAction((prev) => ({
      ...prev,
      SourceRisque: event.target.value as string[],
    }))
  }

  const handleSecurityChange = (
    event: SelectChangeEvent<string | string[]>
  ) => {
    const value = event.target.value
    const controlId = Array.isArray(value) ? value[0] : value
    setSecurityControlIds(controlId)
    setAction((prev) => ({
      ...prev,
      SecurityControlIds: controlId ? [controlId] : [],
    }))
  }

  const handlePriorityChange = (event: SelectChangeEvent<number>) => {
    setAction((prev) => ({
      ...prev,
      Priority: Number(event.target.value),
    }))
  }

  const handleTypeAction = (event: SelectChangeEvent<string>) => {
    setAction((prev) => ({ ...prev, TypeAction: event.target.value }))
  }

  const handleStatusChange = (event: SelectChangeEvent<string>) => {
    setAction((prev) => ({ ...prev, Status: event.target.value }))
  }

  const handleSecurityChange1 = (
    event: SelectChangeEvent<string | string[]>
  ) => {
    const value = event.target.value
    const securityId = Array.isArray(value) ? value[0] : value
    setSecurityIds(securityId)
    setAction((prev) => ({
      ...prev,
      SecurityIds: securityId ? [securityId] : [],
    }))
  }

  const handleSubDomainChange = (
    newSelectedSubDomainIds: string | string[]
  ) => {
    const subDomainId = Array.isArray(newSelectedSubDomainIds)
      ? newSelectedSubDomainIds[0]
      : newSelectedSubDomainIds
    setSubDomainIds(subDomainId)
    setAction((prev) => ({
      ...prev,
      SubDomainIds: subDomainId ? [subDomainId] : [],
    }))
  }

  const [action, setAction] = useState({
    ActionName: '',
    Description: '',
    DateDebut: new Date(),
    DateFin: new Date(),
    Status: 'A faire',
    Source: '',
    Priority: 3,
    Cout: 0,
    CoutTotal: 0,
    DateFinSupp: new Date(),
    MissionId: idmission || '',
    TypeAction: 'IT',
    ProjetId: idprojet || '',
    ActionId: '',
    SourceAudit: [] as string[],
    SourceRisque: [] as string[],
    SourceIncident: [] as string[],
    SecurityIds: [] as string[],
    SecurityControlIds: [] as string[],
    SubDomainIds: [] as string[],
    Support: null as File | null,
  })

  const projectBudget = useProjectBudget(action.ProjetId || undefined)
  const fmt = useNumberFormat()

  const securityControls = useSelector(
    (state: RootState) => state.securitycheckFamily.SecurityControls
  )
  const securityFamilies = useSelector(
    (state: RootState) =>
      state.securitycheckFamily.SecurityCheckFamilyResponse?.securityCheckFamilies
  )
  const subDomains = useSelector(
    (state: RootState) => state.subDomain.subDomainsbySecurityControls
  )

  const [alert, setAlert] = useState({
    open: false,
    message: '',
    severity: '' as 'info' | 'success' | 'error' | 'warning',
    status: 0,
  })

  useEffect(() => {
    dispatch(getMissions({ page: 1, pageSize: 5 }))
  }, [dispatch])

  const handleInputChange = createSanitizedObjectHandler(setAction, {
    ActionName: 'text',
    Description: 'text',
    Source: 'text',
    Cout: 'numbers',
    CoutTotal: 'numbers',
  })

  const handleCloseAlert = () => {
    setAlert({ ...alert, open: false })
  }

  const handleAddAction = async () => {
    const isValidAction = [
      action.ActionName,
      action.Description,
      action.DateDebut,
      action.DateFin,
      action.Status,
      action.Priority,
      action.TypeAction,
    ].every(Boolean)

    if (!isValidAction) {
      setAlert({
        open: true,
        message: t('alerts.actionAdd.emptyFields'),
        status: 0,
        severity: 'warning',
      })
      return
    }
    const limit = projectLimitViolation(projectBudget.data, {
      cost: Number(action.Cout) || 0,
      start: action.DateDebut,
      end: action.DateFin,
    })
    if (limit && projectBudget.data) {
      const info = projectBudget.data
      setAlert({
        open: true,
        message:
          limit === 'cost'
            ? t('parentLimits.costOver', { available: fmt.money(info.remaining) })
            : t('parentLimits.datesOutside', {
                start: formatTableDate(info.projet.DateDebut, i18n.language),
                end: formatTableDate(info.projet.DateFin, i18n.language),
              }),
        status: 400,
        severity: 'warning',
      })
      return
    }
    const { ActionId, ...actionWithoutId } = action
    const response = await dispatch(addAction(actionWithoutId))

    if (response.meta.requestStatus === 'fulfilled') {
      const selectedSecurityControl = securityControls?.find(
        (control) => control._id === SecurityControlIds
      )

      if (
        selectedSecurityControl &&
        selectedSecurityControl.IsComplete === false
      ) {
        const family = securityFamilies?.find((item) => item._id === SecurityIds)
        const subDomain = subDomains?.find((item) => item._id === SubDomainIds)
        setIncompleteSecurityControlName(selectedSecurityControl.Label)
        setMaturityFixTarget({
          familyId: SecurityIds,
          controlId: SecurityControlIds,
          subDomainId: SubDomainIds,
          familyLabel: family?.LabelSCF || '',
          controlLabel: selectedSecurityControl.Label || '',
          subDomainLabel: subDomain?.LabelSD || subDomain?.Label || '',
        })
        setOpenIncompletePopup(true)
      } else {
        setOpenActorPopup(true)
      }

      setAlert({
        open: true,
        message: t('alerts.actionAdd.success'),
        status: 200,
        severity: 'success',
      })
      setAction({
        ActionName: '',
        Description: '',
        DateDebut: new Date(),
        DateFin: new Date(),
        Status: 'A faire',
        Source: '',
        Priority: 3,
        Cout: 0,
        CoutTotal: 0,
        DateFinSupp: new Date(),
        MissionId: action.MissionId || '',
        TypeAction: '',
        ProjetId: action.ProjetId || '',
        ActionId: (response?.payload as { _id?: string })?._id || '',
        SourceAudit: [],
        SourceRisque: [],
        SourceIncident: [],
        SecurityIds: [],
        SubDomainIds: [],
        SecurityControlIds: [],
        Support: null,
      })
      setSecurityIds('')
      setSecurityControlIds('')
      setSubDomainIds('')
    } else if (response.meta.requestStatus === 'rejected') {
      const errorMessage = response.payload as string
      if (
        errorMessage &&
        errorMessage.includes('Weight and TargetScore are required')
      ) {
        setAlert({
          open: true,
          message: t('alerts.actionAdd.weightTargetRequired'),
          status: 400,
          severity: 'error',
        })
      } else {
        setAlert({
          open: true,
          message: errorMessage || t('alerts.actionAdd.error'),
          status: 400,
          severity: 'error',
        })
      }
    }
  }

  const submitLabel = t('actionCreate.submit')
  const formSteps = [
    {
      title: t('actionCreate.sections.identification.title'),
      fieldCount: 2,
    },
    { title: t('actionCreate.sections.origin.title'), fieldCount: 5 },
    { title: t('actionCreate.sections.proof.title'), fieldCount: 1 },
    { title: t('actionCreate.sections.planning.title'), fieldCount: 5 },
    { title: t('actionCreate.sections.security.title'), fieldCount: 3 },
  ]

  return (
    <>
      <div className="page-content">
        <FormPageHead
          eyebrow={t('actionCreate.eyebrow')}
          title={t('buttons.addTask')}
          subtitle={t('actionCreate.subtitle')}
          backLabel={t('actionCreate.backToList')}
          onBack={leave}
          extra={
            <ImportTasksButton
              missionId={idmission}
              projectId={idprojet}
              onImported={(created, failed) => {
                setAlert({
                  open: true,
                  message: failed
                    ? t('actionImport.alerts.partial', { created, failed })
                    : t('actionImport.alerts.success', { count: created }),
                  severity: failed ? 'warning' : 'success',
                  status: failed ? 400 : 200,
                })
              }}
            />
          }
        />

        <UseAlert
          open={alert.open}
          message={alert.message}
          status={alert.status}
          onClose={handleCloseAlert}
        />

        <FormLayout
          main={
            <FormShell>
              <FormSection
                title={t('actionCreate.sections.identification.title')}
              >
                <FormGrid cols={1}>
                  <FormField
                    label={t('actionCreate.sections.identification.taskName')}
                    required
                  >
                    <input
                      className="incyia-form-inp"
                      name="ActionName"
                      value={action.ActionName}
                      onChange={handleInputChange as any}
                      placeholder={t(
                        'actionCreate.sections.identification.taskNamePh'
                      )}
                      required
                    />
                  </FormField>
                  <FormField
                    label={t(
                      'actionCreate.sections.identification.description'
                    )}
                    required
                  >
                    <textarea
                      className="incyia-form-inp"
                      name="Description"
                      value={action.Description}
                      onChange={handleInputChange as any}
                      placeholder={t(
                        'actionCreate.sections.identification.descriptionPh'
                      )}
                      rows={4}
                      required
                    />
                  </FormField>
                </FormGrid>
              </FormSection>

              <FormSection
                title={t('actionCreate.sections.origin.title')}
                description={t('actionCreate.sections.origin.desc')}
              >
                <FormGrid cols={3}>
                  <FormField
                    label={t('actionCreate.sections.origin.mission')}
                    required
                  >
                    <SelectMission
                      value={action.MissionId}
                      onChange={handleMissionChange}
                      onCreateNew={createFor('mission')}
                      reloadKey={qc.keyOf('mission')}
                    />
                  </FormField>
                  <FormField
                    label={t('actionCreate.sections.origin.project')}
                  >
                    <SelectProjet
                      value={action.ProjetId}
                      onChange={handleProjetChange}
                      MissionId={action.MissionId}
                      onCreateNew={createFor('project')}
                      reloadKey={qc.keyOf('project')}
                    />
                  </FormField>
                  <FormField label={t('actionCreate.sections.origin.audit')}>
                    <SelectAudit
                      value={action.SourceAudit}
                      onChange={handleAuditChange}
                      MissionId={action.MissionId}
                      onCreateNew={createFor('audit')}
                      reloadKey={qc.keyOf('audit')}
                    />
                  </FormField>
                  <FormField
                    label={t('actionCreate.sections.origin.incident')}
                  >
                    <SelectIncident
                      value={action.SourceIncident}
                      onChange={handleIncidentChange}
                      MissionId={action.MissionId}
                      onCreateNew={createFor('incident')}
                      reloadKey={qc.keyOf('incident')}
                    />
                  </FormField>
                  <FormField label={t('actionCreate.sections.origin.risk')}>
                    <SelectRisque
                      value={action.SourceRisque}
                      onChange={handleRisqueChange}
                      MissionId={action.MissionId}
                      onCreateNew={createFor('risk')}
                      reloadKey={qc.keyOf('risk')}
                    />
                  </FormField>
                </FormGrid>
              </FormSection>

              <FormSection
                title={t('actionCreate.sections.proof.title')}
                description={t('actionCreate.sections.proof.desc')}
              >
                <FormGrid cols={1}>
                  <FormField label={t('actionCreate.sections.proof.upload')}>
                    <DocumentSelector
                      label=""
                      file={action.Support}
                      onFileChange={(file) => {
                        if (file instanceof File) {
                          setAction((prev) => ({ ...prev, Support: file }))
                        } else {
                          setAction((prev) => ({ ...prev, Support: null }))
                        }
                      }}
                      fileType="application/pdf"
                    />
                  </FormField>
                </FormGrid>
              </FormSection>

              <FormSection
                title={t('actionCreate.sections.planning.title')}
              >
                <FormGrid cols={3}>
                  <FormField
                    label={t('actionCreate.sections.planning.dates')}
                    span
                    help={
                      projectBudget.data?.projet.DateDebut &&
                      projectBudget.data?.projet.DateFin
                        ? t('parentLimits.datesOutside', {
                            start: formatTableDate(
                              projectBudget.data.projet.DateDebut,
                              i18n.language
                            ),
                            end: formatTableDate(
                              projectBudget.data.projet.DateFin,
                              i18n.language
                            ),
                          })
                        : undefined
                    }
                  >
                    <DateSelector
                      placeholder={t('actionCreate.sections.planning.dates')}
                      onDateChange={handleDateChange}
                      hideLabel
                      minDate={
                        projectBudget.data?.projet.DateDebut
                          ? new Date(projectBudget.data.projet.DateDebut)
                          : null
                      }
                      maxDate={
                        projectBudget.data?.projet.DateFin
                          ? new Date(projectBudget.data.projet.DateFin)
                          : null
                      }
                    />
                  </FormField>
                  <FormField
                    label={t('actionCreate.sections.planning.cost')}
                    required
                    help={t('actionCreate.sections.planning.costHelp')}
                  >
                    <NumberInput
                      currency
                      min={0}
                      name="Cout"
                      value={action.Cout}
                      onChange={(v) => setAction((a: any) => ({ ...a, Cout: v ?? 0 }))}
                      required
                    />
                  </FormField>
                  <FormField
                    label={t('actionCreate.sections.planning.priority')}
                  >
                    <SelectPriority
                      value={action.Priority}
                      onChange={handlePriorityChange}
                      hideLabel
                    />
                  </FormField>
                  <FormField
                    label={t('actionCreate.sections.planning.type')}
                  >
                    <SelectTypeAction
                      value={action.TypeAction}
                      onChange={handleTypeAction}
                      hideLabel
                    />
                  </FormField>
                  <FormField
                    label={t('actionCreate.sections.planning.status')}
                  >
                    <SelectStatut
                      value={action.Status}
                      onChange={handleStatusChange}
                      hideLabel
                    />
                  </FormField>
                </FormGrid>
              </FormSection>

              <FormSection
                title={t('actionCreate.sections.security.title')}
                description={t('actionCreate.sections.security.desc')}
              >
                <FormGrid cols={3}>
                  <FormNote>
                    {t('actionCreate.securitySelectionInfo')}
                  </FormNote>
                  <FormField
                    label={t('Security Check Family', {
                      defaultValue: 'Security Check Family',
                    })}
                  >
                    <SelectSecurity
                      value={SecurityIds}
                      onChange={handleSecurityChange1}
                      multiple={false}
                    />
                  </FormField>
                  <FormField
                    label={t('Security Control', {
                      defaultValue: 'Security Control',
                    })}
                  >
                    {action.SecurityIds ? (
                      <SecurityControlsSelect
                        value={SecurityControlIds}
                        onChange={handleSecurityChange}
                        securityId={SecurityIds}
                        multiple={false}
                      />
                    ) : null}
                  </FormField>
                  <FormField
                    label={t('SubDomain', { defaultValue: 'SubDomain' })}
                  >
                    <SelectSubDomain
                      securityControlIds={SecurityControlIds}
                      selectedSubDomainIds={SubDomainIds}
                      onChange={handleSubDomainChange}
                      multiple={false}
                    />
                  </FormField>
                </FormGrid>
              </FormSection>

              <FormFoot
                note={t('actionCreate.aside.requiredMark')}
                cancelLabel={t('buttons.cancel', { defaultValue: 'Cancel' })}
                submitLabel={submitLabel}
                onCancel={leave}
                onSubmit={handleAddAction}
              />
            </FormShell>
          }
          aside={
            <FormAside
              title={t('actionCreate.aside.inThisForm')}
              tipTitle={t('actionCreate.aside.goodToKnow')}
              tip={t('actionCreate.aside.tip')}
              context={
                action.ProjetId ? (
                  <>
                    <ProjectSummaryCard
                      plain
                      info={projectBudget.data}
                      status={projectBudget.status}
                    />
                    <p className="incyia-aside-note incyia-aside-divider">
                      {t('parentLimits.stayInside')}
                    </p>
                  </>
                ) : undefined
              }
              steps={formSteps}
              requiredCount={4}
              submitLabel={submitLabel}
              fieldsLabel={(n) =>
                t(n === 1 ? 'actionCreate.aside.fields_one' : 'actionCreate.aside.fields_other', {
                  count: n,
                })
              }
              requiredNote={(count, submit) =>
                t('actionCreate.aside.requiredNote', { count, submit })
              }
            />
          }
        />
      </div>

      {openActorPopup && (
        <ActorAction
          actionId={action.ActionId}
          isOpen={openActorPopup}
          returnTo={projectReturn || undefined}
          onClose={() => setOpenActorPopup(false)}
        />
      )}

      <Dialog
        open={openIncompletePopup}
        onClose={() => {
          pendingMaturityNav.current = false
          setOpenIncompletePopup(false)
          setOpenActorPopup(true)
        }}
        TransitionProps={{
          onExited: () => {
            if (!pendingMaturityNav.current || !maturityFixTarget) return
            pendingMaturityNav.current = false
            navigate('/maturite', {
              state: {
                highlightSecurityCheckFamily: maturityFixTarget.familyId,
                highlightSecurityControl: maturityFixTarget.controlId,
                highlightSubDomain: maturityFixTarget.subDomainId,
                familyLabel: maturityFixTarget.familyLabel,
                controlLabel: maturityFixTarget.controlLabel,
                subDomainLabel: maturityFixTarget.subDomainLabel,
              },
            })
          },
        }}
        fullWidth
        maxWidth="sm"
        PaperProps={{ className: 'incyia-modal-paper incyia-fix-dialog' }}
      >
        <div className="incyia-modal-head">
          <div>
            <h3>{t('alerts.incompleteSecurityControl.title')}</h3>
            <p>
              {t('alerts.incompleteSecurityControl.message', {
                controlName: incompleteSecurityControlName,
              })}
            </p>
          </div>
        </div>
        {maturityFixTarget ? (
          <div className="incyia-modal-body">
            <div className="incyia-combo">
              <div className="incyia-combo-item">
                <span className="incyia-combo-k">
                  {t('maturityManagementPage.familyLabel')}
                </span>
                <span className="incyia-combo-v">
                  {maturityFixTarget.familyLabel || '—'}
                </span>
              </div>
              <div className="incyia-combo-item">
                <span className="incyia-combo-k">
                  {t('Security Control', { defaultValue: 'Security Control' })}
                </span>
                <span className="incyia-combo-v">
                  {maturityFixTarget.controlLabel || '—'}
                </span>
              </div>
              <div className="incyia-combo-item">
                <span className="incyia-combo-k">{t('Subdomain')}</span>
                <span className="incyia-combo-v">
                  {maturityFixTarget.subDomainLabel || '—'}
                </span>
              </div>
            </div>
          </div>
        ) : null}
        <div className="incyia-modal-foot">
          <DetailButton
            variant="ghost"
            onClick={() => {
              pendingMaturityNav.current = false
              setOpenIncompletePopup(false)
              setOpenActorPopup(true)
            }}
          >
            {t('alerts.incompleteSecurityControl.skip')}
          </DetailButton>
          <DetailButton
            onClick={() => {
              pendingMaturityNav.current = true
              setOpenIncompletePopup(false)
            }}
          >
            {t('alerts.incompleteSecurityControl.fixNow')}
          </DetailButton>
        </div>
      </Dialog>
      <QuickCreate request={qc.request} onClose={qc.close} onCreated={handleQuickCreated} />
    </>
  )
}

export default ActionCreate
